import type { FaireProductEntity } from "../../entity_types/product";

export const p_mvrqktpxk2: FaireProductEntity = {
  token: "p_mvrqktpxk2",
  type: "product",
  name: "Bridget Sweater - Harbor (Faire Pre-Order)",
  brandToken: "b_9ut9ansxk1",
  brandName: "The Endery",
  imageUrl: "https://cdn.faire.com/fastly/edaa4464ce730229e76ecd4e39af422ae69c9264d722e509a1919c137e43daca.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/34232964fd9291c1a3e7081a505605bf4783a47ffd69c36ae7ede893a42d825d.jpeg",
    "https://cdn.faire.com/fastly/1b63c4734594a3bf17abd02e17bfbd993cf3c6c8e81a9d4c1a436376477bf3db.jpeg",
    "https://cdn.faire.com/fastly/32aa8ed27bcdacd42b8c578b43edfdc59589f8afed7f0b139ebd881abb355836.jpeg",
    "https://cdn.faire.com/fastly/3a8d5f32ca8c00555153e5ab4c0e3ed3ba8fd0e44e6faa777372e3ea646f339d.jpeg",
    "https://cdn.faire.com/fastly/09aca150f44a786888bd16b584b0215e61224faf2886db2e39c01f349e39b290.jpeg",
    "https://cdn.faire.com/fastly/fa3caf061b905f9e9c9ade282c10aa91f4d6cd838d63795f05f6a1386a97fe7c.jpeg",
    "https://cdn.faire.com/fastly/8479ddbb617a4404366e76635177f1d25e35d60e981abfe8443e6fb9411be2aa.jpeg",
    "https://cdn.faire.com/fastly/81d499a6a2a8f1db9c03c6f5c9c1a6c36611fd47df69a84f80863224799395c2.jpeg",
    "https://cdn.faire.com/fastly/da5f0c98640731334e2a071ace47821a0e0dbf91c176cf66163be42c6cecf874.jpeg"
  ],
  priceDollars: 111.6,
  description: "A grid that shifts as you look at it, borrowed from the op art of Bridget Riley. Double knit means two faces worked as one — that is where the warmth comes from, without the stiffness.\n\n * 100% Merino Wool \n * Artisan made in Peru with Fair Trade practices to maintain ethical and responsible integrity \n * Relaxed and straight through the body, in a v-neck ",
  tags: [],
  msrpDollars: 248,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-13T05:50:21.095Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
